export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11287.d5aae3ed.jpg";